import firebase from 'firebase/app';
import 'firebase/messaging';
const { log } = console;

const firebaseConfig = {
  apiKey: 'AIzaSyDelEzws4QtrfYkvO7Ysbu2Jxs3WgRN1LM',
  authDomain: 'fcm-demo-sms.firebaseapp.com',
  projectId: 'fcm-demo-sms',
  storageBucket: 'fcm-demo-sms.appspot.com',
  messagingSenderId: '24364247800',
  appId: '1:24364247800:web:39cd50da0290db4c0be90d',
  measurementId: 'G-6TT323N48Q',
};

console.log('***FCM Init: Foreground***');
firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();
console.log('***FCM Enabled: Foreground***');

export const getFirebaseToken = async (refreshCallBack = undefined) => {
  log({
    page: 'firebase',
    function: 'getFirebaseToken',
    name: 'initializeFirebaseToken-> getFirebaseToken',
    data: {
      refreshCallBack      
    },
    message: 'Trying to generate firebase token.',
    date: new Date()
  })
  try {
    log({
      page: 'firebase',
      function: 'initializeFirebaseToken-> getFirebaseToken',
      name: 'initializeFirebaseToken',
      data: {
        refreshCallBack      
      },
      message: 'Calling getToken function from firebase library.',
      date: new Date()
    })
    const currentToken =
      process.env.REACT_APP_FCM_LOCAL_TESTING === 'false'
        ? await messaging.getToken()
        : await messaging.getToken({
            vapidKey:
              'BMpF3ewHCKWYpNVDJu3CRqslM8LJP9E9aXNiUiAvj6sBIooRWWzaKX29UN5U_EmbXhAhDMYcRhpsLrNYCpQ0Pkc',
          });
    log({
      page: 'firebase',
      function: 'initializeFirebaseToken-> getFirebaseToken',
      name: 'initializeFirebaseToken',
      data: {
        refreshCallBack
      },
      message: 'Calling getToken function from firebase library.',
      date: new Date()
    })
    if (currentToken) {
      log({
        page: 'firebase',
        function: 'initializeFirebaseToken-> getFirebaseToken',
        name: 'initializeFirebaseToken',
        data: {
          refreshCallBack,
          currentToken
        },
        message: 'Getting token',
        date: new Date()
      })
      console.log('FCM token for client: ', currentToken);
      return currentToken;
      // Track the token -> client mapping, by sending to backend server
      // show on the UI that permission is secured
    } else {
      log({
        page: 'firebase',
        function: 'initializeFirebaseToken-> getFirebaseToken',
        name: 'initializeFirebaseToken',
        data: {
          refreshCallBack
        },
        message: 'Error while taking token from firebase',
        date: new Date()
      })
      console.log(
        'No registration token available. Request permission to generate one.'
      );
      return false;
      // shows on the UI that permission is required
    }
  } catch (err) {
    log({
      page: 'firebase',
      function: 'initializeFirebaseToken-> getFirebaseToken',
      name: 'initializeFirebaseToken',
      data: {
        refreshCallBack
      },
      message: 'Error message from firebase registration ' + err,
      date: new Date()
    })
    console.log('An error occurred while retrieving token. ', err);
    if (
      err &&
      err.message &&
      err.message.includes('no active Service Worker')
    ) {
      log({
        page: 'firebase',
        function: 'initializeFirebaseToken-> getFirebaseToken',
        name: 'initializeFirebaseToken',
        data: {
          refreshCallBack
        },
        message: 'Trying to regenerate firebasetoken',
        date: new Date()
      })
      refreshCallBack && refreshCallBack();
    }
  }
};

export const deleteFirebaseToken = async () => await messaging.deleteToken();

export const onMessageListenerFCM = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });



// WEBPACK FOOTER //
// ./src/config/firebase.js